import React from 'react';
import { LargeModaleWithLeftPane, PlanPriceDetails } from 'components';

import { useTranslation } from 'react-i18next';
import { createUseStyles, useTheme } from 'react-jss';
import { usePlan, Session } from '@app/api';
import { Theme } from '@app/theme';
import { UsageDetails } from './UsageDetails';
import { SessionInvoices } from './SessionInvoices';

const useStyles = createUseStyles((theme: Theme) => ({
  prices: {
    marginTop: theme.marginBase * 3,
  },
  container: {
    position: 'relative',
    padding: theme.marginBase * 3,
    height: '100%',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.marginBase * 3 + 'px',
  },
  paneWidth: {
    width: theme.marginBase * 45,
  },
}));

interface Props {
  isOpen: boolean;
  onRequestClose: () => void;
  session: Session;
}

export const SessionBillingDetailsModal = ({
  isOpen,
  onRequestClose,
  session,
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();
  const { data: plan } = usePlan(session?.planId);

  return (
    <LargeModaleWithLeftPane
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      paneClassName={classes.paneWidth}
      paneTitle={session && t('billing.pricePane.title')}
      paneContent={
        session &&
        plan && (
          <PlanPriceDetails
            totalOnly={false}
            className={classes.prices}
            session={session}
            plan={plan}
            defaultOpened={false}
          />
        )
      }
    >
      <div className={classes.container}>
        <UsageDetails session={session} />
        <SessionInvoices sessionId={session.id} />
      </div>
    </LargeModaleWithLeftPane>
  );
};
